<template>
	<div class="card">
		<div class="card-body">
			<div class="flex flex-wrap items-center justify-between gap-3">
				<div class="card-title flex items-center gap-2">
					<span class="loading" v-if="projectStore.loading.listProjects"></span>
					<span>{{ _tr('project.AllProjects') }}</span>
				</div>

				<div class="flex flex-1 flex-wrap items-center justify-end gap-3">
					<div class="flex flex-row items-center gap-2">
						<label class="input input-sm">
							<Search />
							<input
								type="search"
								:placeholder="_tr('project.filter')"
								:aria-label="_tr('project.filter')"
								v-model="search" />
						</label>

						<button class="btn btn-soft btn-primary btn-sm" @click="handleOpenNewProjectModal">
							{{ _tr('project.addNewProject') }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<ProjectAddNewModal />
</template>

<script setup lang="ts">
	import { useI18n } from 'vue-i18n'
	import { useVfm } from '@/libs/modals'
	import { Search } from 'lucide-vue-next'
	import { _translations } from './_translations'
	import { useProjectsData } from './_useProjects'
	import ProjectAddNewModal from './ProjectAddNew.modal.vue'
	import { useAuthStore } from '@/stores/auth.store'
	import { useProjectStore } from '@/stores/projects.store'

	const { t: _tr } = useI18n(_translations)
	const vfm = useVfm()
	const authStore = useAuthStore()
	const projectStore = useProjectStore()
	const { search } = useProjectsData()

	const handleOpenNewProjectModal = () => {
		vfm.open('add-new-project')
	}
</script>
